import { render, staticRenderFns } from "./brand-easy.vue?vue&type=template&id=f6945e9c&"
import script from "./brand-easy.vue?vue&type=script&lang=js&"
export * from "./brand-easy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports